import React, { Component } from 'react';
import './../css/master.css';
import './../css/csDispatch.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';

var httpURL = '';
var queryString = require('querystring');
var lstDispatch = [];

class CSDispatch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			designImagePath: require('./../images/blank.png'),
			loader: 'none',
			opacity: 1,
			dispatch: [],
			width1: '97%',
			totalQuantity: 0,
			quantityColor: '',
		}
	}

	async componentWillUnmount() {
		await localStorage.removeItem('dispatch');
	}

	async componentDidMount() {
		console.log('componentDidMount called');
		$('#undoCompleted').addClass('disabled');
		var detail = await localStorage.getItem('dispatch');
		var details = JSON.parse(detail);
		$('#ipoId').val(details.ipoId);
		$('#ipoNo').val(details.ipoNo);
		$('#bpoId').val(details.bpoId);
		$('#bpoNo').val(details.bpoNo);
		$('#ipoDesignId').val(details.ipoDesignId);
		$('#designId').val(details.designId);
		$('#designNoColor').val(details.designNoColor);
		$('#bpoStyleId').val(details.bpoStyleId);
		$('#styleColor').val(details.style + '-' + details.color);
		$('#quality').val(details.quality);
		$('#length').val(details.length);
		$('#width').val(details.width);
		$('#yarnCount').val(details.yarnCount);
		$('#construction').val(details.construction);
		console.log(details.imageUrl);
		this.setState({
			designImagePath: details.imageUrl,
		});
		this.dispatchFunction();
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}

	handleResize = () => {
		var width1 = ($('.tableLayout1').parent().width()) - 17;
		this.setState({ width1: width1 })
	}

	dispatchFunction = () => {
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/ipo/disp/listdispatch',
			queryString.stringify({ 'ipoDesignId': $('#ipoDesignId').val() }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					dispatch: response.data.lstDispatch,
					totalQuantity: response.data.totalQuantity,
					quantityColor: $('#length').val() > response.data.totalQuantity ? 'red' : 'green',
				});
				$('#order_completed').prop('checked', response.data.orderCompleted);
				if (response.data.orderCompleted == true) {
					$('#undoCompleted').removeClass('disabled');

				}
				else {
					$('#undoCompleted').addClass('disabled');
				}
				lstDispatch = this.state.dispatch;
				this.setDispatchTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'No Dispatch Data exist for this IPO Design') {
					lstDispatch = [];
					this.setDispatchTable();
				}

				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setDispatchTable = () => {
		$('#dispatchTbody tr').remove();
		var table = document.getElementById('dispatchTable');
		var tbody = document.getElementById('dispatchTbody');

		for (var i = 0; i < lstDispatch.length; i++) {
			var dispatchId = lstDispatch[i].dispatchId;
			var dispatchDt = lstDispatch[i].dispatchDt;
			var invoiceNo = lstDispatch[i].invoiceNo;
			var quantity = lstDispatch[i].quantity;
			var statusId = lstDispatch[i].statusId;
			var wvrSubmitDt = lstDispatch[i].wvrSubmitDt;
			var actionDt = lstDispatch[i].csActionDt;

			var row = document.createElement('tr');
			this.addTD(row, dispatchId, 'text-right no-display');
			this.addTD(row, dispatchDt, 'text-center');
			this.addTD(row, invoiceNo, '');
			this.addTD(row, quantity, 'text-right');
			this.addTDCmb(row, statusId, '')
			this.addTD(row, wvrSubmitDt, 'text-center');
			this.addTD(row, actionDt, 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	addTDCmb(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var select = document.createElement('select');
		select.className = 'form-control';
		select.addEventListener('change', this.changeStatus);
		var option1 = document.createElement('option');
		var option2 = document.createElement('option');
		option1.value = 1;
		option2.value = 2;
		option1.innerHTML = 'Pending';
		option2.innerHTML = 'Recieved';
		select.append(option1);
		select.append(option2);
		cell.append(select);
		select.value = val;
		if (val == 2) {
			select.setAttribute('disabled', true);
		} else {
			select.removeAttribute('disabled', false);
		}
		row.append(cell);
	}

	changeStatus = (e) => {
		var dispatch = {};
		var statusId = $(e.target).find('option:selected').val();
		var dispatchId = $(e.target).closest('tr').find('td:eq(0)').text();
		var ipoDesignId = $('#ipoDesignId').val();

		dispatch = { ipoDesignId, dispatchId, statusId };

		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/ipo/disp/save',
			queryString.stringify({ 'dispatch': JSON.stringify(dispatch) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				toast.success(response.data.SvcMsg);
				var dispIdx = this.getDispIdx(dispatchId);
				if (dispIdx != -1) {
					lstDispatch[dispIdx].statusId = 2;
					lstDispatch[dispIdx].csActionDt = response.data.csActionDt;
					this.setDispatchTable();
				}
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	getDispIdx = (id) => {
		for (var i = 0; i < lstDispatch.length; i++) {
			if (id == lstDispatch[i].dispatchId) {
				return i;
			}
		}
		return -1;
	}
	undoCompleted = () => {
		var retVal = window.confirm("Do you want to undo Completed ?");
		if (retVal == true) {
			this.undoComplete();
			return true;
		} else {
			return false;
		}
	}

	undoComplete = () => {
		var ipoDesignId = $('#ipoDesignId').val();
		if ($('#order_completed').prop('checked')) {
			this.setState({ loader: 'block', opacity: 0.5 });
			axiosInstance.post(httpURL + '/a/bpo/disp/wvr/undocompleted',
				queryString.stringify({ 'ipoDesignId': ipoDesignId }), { withCredentials: true }
			).then((response) => {
				if (response.data.SvcStatus === 'Success') {
					toast.success(response.data.SvcMsg);
					$('#order_completed').prop('checked', false)
					$('#undoCompleted').addClass('disabled');
				}
				else {
					toast.error(response.data.SvcMsg);
					if (response.data.SvcMsg == 'You are not logged in') {
						window.location.href = window.CSURL;
						return false;
					}
					$('#order_completed').prop('checked', false);
				}
				this.setState({ loader: 'none', opacity: 1 });
			}).catch((error) => {
				toast.error("Service failed " + error);
			});
		}
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader, zIndex: 9999 }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<div className="row">
								<div className="col-sm-10" style={{ paddingLeft: 0 }}>
									<div className="styleBackground">
										<form className="form-inline">
											<div className="form-group">
												<label style={{ width: 100 }} htmlFor="ipoNo">IPO NO:</label>
												<input style={{ display: 'none' }} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
												<input style={{ display: 'none' }} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
												<input style={{ marginLeft: 2 }} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="bpoNo">BPO NO:</label>
												<input style={{ display: 'none' }} placeholder="BPO Id" type="text" className="form-control" id="bpoId" />
												<input style={{ marginLeft: 2 }} readOnly placeholder="BPO Number" type="text" className="form-control" id="bpoNo" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="designNoColor">Design Color:</label>
												<input style={{ display: 'none' }} placeholder="Design Id" type="text" className="form-control" id="designId" />
												<input style={{ marginLeft: 2 }} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
											</div>
										</form>
										<form className="form-inline" style={{ marginTop: 5 }}>
											<div className="form-group">
												<label style={{ width: 100 }} htmlFor="quality">Quality:</label>
												<input style={{ marginLeft: 2 }} readOnly placeholder="Quality" type="text" className="form-control" id="quality" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="length">Length:</label>
												<input style={{ marginLeft: 2 }} readOnly placeholder="Length" type="text" className="form-control text-right" id="length" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="width">Width:</label>
												<input style={{ marginLeft: 2 }} readOnly placeholder="Width" type="text" className="form-control" id="width" />
											</div>
										</form>
										<form className="form-inline" style={{ marginTop: 5 }}>
											<div className="form-group">
												<label style={{ width: 100 }} htmlFor="yarnCount">Yarn Count:</label>
												<input style={{ marginLeft: 2 }} readOnly placeholder="Yarn Count" type="text" className="form-control" id="yarnCount" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="construction">Construction:</label>
												<input style={{ marginLeft: 2 }} readOnly placeholder="Construction" type="text" className="form-control" id="construction" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="styleColor">Style-Color:</label>
												<input style={{ display: 'none' }} placeholder="Style Id" type="text" className="form-control" id="bpoStyleId" />
												<input style={{ marginLeft: 2 }} readOnly placeholder="Style-Color" type="text" className="form-control" id="styleColor" />
											</div>
										</form>
									</div>
								</div>
								<div className="col-sm-2 padding-remove" id="designColorImageDivCSDispatch">
									<ReactImageMagnify {...{
										smallImage: {
											alt: 'Design Image',
											src: this.state.designImagePath,
											isFluidWidth: true,
										},
										largeImage: {
											src: this.state.designImagePath,
											width: 600,
											height: 900
										},
										enlargedImageContainerDimensions: {
											width: 300,
											height: 300,
										},
										enlargedImageContainerStyle: {
											left: -185,
											top: 125,
										},
									}} />
								</div>
							</div>
							<div className="row">
								<div className="form-inline text-center" style={{ marginTop: 10, width: 300, borderTopLeftRadius: 6, borderTopRightRadius: 6, background: '#cee0ce', display: 'inline-block' }}>
									<label htmlFor="">Order Completed from Weaver:</label>
									<div className="checkbox" style={{ marginLeft: 5 }}>
										<input disabled type="checkbox" id="order_completed" />
									</div>
								</div>
								<span id="undoCompleted" title="Undo Completed" className="undoCompleted" onClick={this.undoCompleted}> Undo Completed </span>
							</div>
							<div className="row" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
								<div>
									<table className="tableLayout1" style={{ width: this.state.width1 }}>
										<thead>
											<tr>
												<th style={{ width: 100, display: 'none' }}>Dispatch Id</th>
												<th style={{ width: 100 }}>Dispatch Date</th>
												<th style={{ width: 100 }}>Invoice No. </th>
												<th style={{ width: 100 }}>Quantity</th>
												<th style={{ width: 100 }}>Status</th>
												<th style={{ width: 100 }}>Weaver Submit Date</th>
												<th style={{ width: 100 }}>Action Date</th>
											</tr>
										</thead>
									</table>
									<div style={{ height: 300, overflowY: 'scroll' }}>
										<table className="tableLayout" id="dispatchTable">
											<colgroup>
												<col style={{ width: 100 }} />
												<col style={{ width: 100 }} />
												<col style={{ width: 100 }} />
												<col style={{ width: 100 }} />
												<col style={{ width: 100 }} />
												<col style={{ width: 100 }} />
											</colgroup>
											<tbody id="dispatchTbody"></tbody>
										</table>
									</div>
								</div>
								<div>
									<span onClick={this.dispatchFunction} title="Refresh" style={{ fontSize: 20, paddingLeft: 10, cursor: 'pointer' }} className="glyphicon glyphicon-refresh"></span>
								</div>
							</div>
							<div className="row text-right" style={{ marginTop: 20, marginRight: 0 }}>
								<span className="digitalFont" style={{ fontSize: 20, fontWeight: 'bold', color: this.state.quantityColor }}>Total Quantity: {this.state.totalQuantity}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CSDispatch;
